import type { SupportedLanguage } from '@dx-ui/framework-i18n';

export const DEFAULT_LOCALE: SupportedLanguage = 'en';

export type RouterContextValue = {
  locale: SupportedLanguage;
  defaultLocale: SupportedLanguage;
  pathname: string;
  pathSegments: string[];
  asPath: string;
  isReady: boolean;
  query: Record<string, string | string[] | undefined>;
  params: Record<string, string | string[] | undefined>;
};
